/**
 * 获取站点名称
 * @returns 站点名称
 */
export function getSiteName(): string {
  return '智盒-AI'
}

/**
 * 获取站点 Logo 路径
 * @returns 站点 Logo 静态路径
 */
export function getSiteLogo(): string {
  return '/logo.png'
}

export const SITE_NAME = getSiteName()
export const SITE_LOGO = getSiteLogo()
